// src/components/Dashboard/Sidebar.jsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaTachometerAlt, FaUser, FaCalendarCheck, FaAward, FaSignOutAlt } from 'react-icons/fa';

const SidebarLink = ({ to, icon, children }) => (
  <NavLink
    to={to}
    end
    className={({ isActive }) =>
      `flex items-center gap-4 px-4 py-3 rounded-lg font-semibold transition-colors ${
        isActive
          ? 'bg-blue-600 text-white shadow-md'
          : 'text-slate-600 hover:bg-blue-100 hover:text-blue-700'
      }`
    }
  >
    {icon}
    <span>{children}</span>
  </NavLink>
);

const PlayerSidebar = ({ onLogout }) => {
  // This will be expanded later to handle different roles (admin, secretary)
  const role = 'player'; 

  const handleLogout = async () => {
    if (typeof onLogout === "function") {
      await onLogout();
    }
  };

  return (
    <aside className="bg-white w-64 min-h-screen p-4 flex flex-col shadow-lg">
      <div className="flex items-center gap-3 mb-8 px-2">
        <img src="/images/parasports.png" alt="Logo" className="w-10 h-auto" />
        <span className="font-bold text-xl text-slate-800">Player Dashboard</span>
      </div>
      
      <nav className="flex-grow space-y-2">
        {role === 'player' && (
          <>
            <SidebarLink to="/player" icon={<FaTachometerAlt />}>Dashboard</SidebarLink>
            <SidebarLink to="/player-profile" icon={<FaUser />}>My Profile</SidebarLink>
            <SidebarLink to="/player/my-registrations" icon={<FaCalendarCheck />}>My Registrations</SidebarLink>
            <SidebarLink to="/certificates" icon={<FaAward />}>My Certificates</SidebarLink>
          </>
        )}
        {/* Add links for other roles here later using if/else if */}
      </nav>

      <div className="mt-auto">
        <button
          onClick={handleLogout}
          className="flex items-center gap-4 px-4 py-3 rounded-lg font-semibold text-slate-600 hover:bg-red-100 hover:text-red-700 w-full transition-colors"
        >
          <FaSignOutAlt />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default PlayerSidebar;
